import cookie from 'react-cookie';

export default (() => {

    const COOKIE_ACCEPT = 'COOKIE_ACCEPT';

    function cookies() {
        if (window.localStorage.getItem('localStorage')) {
            return window.localStorage.getItem(COOKIE_ACCEPT);
        } else {
            return cookie.load(COOKIE_ACCEPT);
        }
    }

    function get() {
        const cCheck = cookies();

        if(cCheck === null || cCheck === undefined) {
            return false;
        }
        else {
            return true;
        }
    }

    function set() {
        if (window.localStorage.getItem('localStorage')) {
            window.localStorage.setItem(COOKIE_ACCEPT, JSON.stringify(COOKIE_ACCEPT));
        } else {
            cookie.save(COOKIE_ACCEPT, JSON.stringify(COOKIE_ACCEPT));
        }
    }

    return {
        cookies,
        get,
        set
    }
})();


// WEBPACK FOOTER //
// ./services/cookies.js